import React from 'react';
import Moment from 'moment';

import InOutDashboardContext from '../../services/inOutDashboard/InOutDashboardContext';

import Styles from '../../styles/componentStyle/inOutDashboard/InOutDashboard.scss';

/**
 * 入退場実績詳細テーブル
 * */
export const RecordTableLayout = () => {
  // 画面表示
  return (
    <InOutDashboardContext.Consumer>
      {({ state }) => (
        <div className={`${Styles.achievementTable} dashboard-table`}>
          <table className='dashboard-table__table'>
            <tbody>
              <tr className='dashboard-table__tr'>
                <td className='dashboard-table__label'>
                  <div className='label'>
                    {Moment(state.inOutRecord.target_date_before).format(
                      data.title.dateFormat
                    )}
                  </div>
                </td>
                <td className='dashboard-table__content'>
                  <div className='content_left'>{data.title.enteredCount}</div>
                  <div className='content_right'>
                    {state.inOutRecord.target_date_before_entered_count}
                    {data.count}
                  </div>
                </td>
              </tr>
              <tr className='dashboard-table__tr'>
                <td className='dashboard-table__label'>
                  <div className='label'>
                    {Moment(state.inOutRecord.target_date).format(
                      data.title.dateFormat
                    )}
                  </div>
                </td>
                <td className='dashboard-table__content'>
                  <div className='content_left'>{data.title.enteredCount}</div>
                  <div className='content_right'>
                    {state.inOutRecord.target_date_entered_count}
                    {data.count}
                  </div>
                </td>
              </tr>
              <tr className='dashboard-table__tr'>
                <td className='dashboard-table__label' />
                <td className='dashboard-table__content'>
                  <div className='content_left'>{data.title.exitCount}</div>
                  <div className='content_right'>
                    {state.inOutRecord.target_date_exit_count}
                    {data.count}
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      )}
    </InOutDashboardContext.Consumer>
  );
};

// 定数
const data = {
  title: {
    dateFormat: 'MM/DD(ddd)',
    enteredCount: '入場者数',
    exitCount: '退場者数',
  },
  count: '人',
};



// WEBPACK FOOTER //
// ./src/components/tables/InOutDashboardRecordTable.jsx